import styled from 'styled-components';
import { Typ40 } from 'dc/Typ';
import Lab402 from 'dc/Lab402';
import ToTl from 'dc/ToTl';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: flex;
  padding: 80px 0;
  flex-direction: column;
  align-items: center;
  background: #fff;
  @media only screen and (max-width: 600px) {
    padding: 0 16px 0;
  }
`;

export const InnerWrapper = styled.div`
  margin-bottom: 88px;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const Text = styled(Typ40)`
  display: block;
  padding-left: 15px;
  color: #546e7a;
  text-transform: uppercase;
  margin: 25px 0 32px;
  @media only screen and (max-width: 600px) {
    padding-left: 0;
    margin: 40px 0 24px;
    font-size: 10px;
    line-height: 12px;
  }
`;

export const TimelineItem = styled(Lab402)`
  width: 572px;
  margin-bottom: 32px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    padding-left: 0;
    div {
      padding-right: 0;
      &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        border-bottom: 1px solid #bcbbc1;
        content: '';
      }
    }
  }
`;

export const SubItemWrapper = styled.div`
  margin-left: 7px;
  display: flex;
  flex-direction: column;
  margin-bottom: 105px;
`;

export const TimelineSubItem = styled(ToTl)`
  width: 572px;
`;
